import React from 'react'
import { navigateTo } from 'gatsby-link'
import styled, { css } from 'styled-components'
import { VelocityComponent } from 'velocity-react'
import Link from 'gatsby-link'

import { container, bgIcon, padding, hoverState, bgImage } from '../../../styles/global'

import { SignupForm } from '../../../components'

class BlockSignUp extends React.Component {

	render() {

		return (
            <Wrapper>

                <SignupForm />

            </Wrapper>
		)
	}
}

const Wrapper = styled.div`

`


BlockSignUp.wrapper = css`
	display: flex;
	justify-content: center;
	${padding};
`

export default BlockSignUp



// WEBPACK FOOTER //
// ./src/components/Block/templates/BlockSignUp.js